export class DatosChat {
	public target: string;
	public targetType: string;
	public encoladoMaximo: number;
	public guardarHistorico: boolean;
	public codigoAsistente: string;
	public descripcionServicio: string;
	public userName: string;
	public requiereEncuesta: boolean;
	public codigoEncuesta: string;
	public habilitado: boolean;
	public enHorario: boolean;
	public horaInicio: string;
	public horaFin: string;
	public agentName: string;
	public codigoAsistenteChat: string;
}
